module.exports = __webpack_public_path__ + "img/jorge-castro.25049b1a.jpg";